export default __webpack_public_path__ + "static/media/40fd9cfe03b70bbe5527d692eac67902.md";